import { render, staticRenderFns } from "./RSLinks.vue?vue&type=template&id=31fa0b4c&scoped=true"
import script from "./RSLinks.vue?vue&type=script&lang=js"
export * from "./RSLinks.vue?vue&type=script&lang=js"
import style0 from "./RSLinks.vue?vue&type=style&index=0&id=31fa0b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fa0b4c",
  null
  
)

export default component.exports